module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#myNavbar",
      "aria-controls": "myNavbar"
    },
    on: {
      "click": function($event) {
        _vm.isCollapsed = !_vm.isCollapsed
      }
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "id": "covered",
      "href": "/"
    }
  }, [_vm._v("Migration Workbench")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    class: { in: !_vm.isCollapsed
    },
    attrs: {
      "id": "myNavbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Dashboard")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/validations",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Validations")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/referentials",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Referentials")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Clinics'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Clinics")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/tasks",
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Team Tasks")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "#",
      "tag": "li",
      "active-class": "active"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openDocSidebar($event)
      }
    }
  }, [_c('a', [_vm._v("About")])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: _vm.userRoute
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [(!_vm.isAuthenticated) ? _c('a', [_c('span', {
    staticClass: "fa fa-lg fa-sign-in"
  }), _vm._v(" Login")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('a', [_c('span', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.currentUser.firstName))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currentUser.lastName))])]) : _vm._e()])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b0f1898","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nav/Nav.vue
// module id = 208
// module chunks = 5